import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'msBetween'
})
export class MsBetweenPipe implements PipeTransform {

    transform(biggestDate: Date, smallestDate: Date): string {
        if (biggestDate === null || smallestDate === null) {
            return '';
        }

        const biggestDateFormatted = new Date(biggestDate).getTime();
        const smallestDateFormatted = new Date(smallestDate).getTime();
        const milliseconds = biggestDateFormatted - smallestDateFormatted;

        if (milliseconds < 1000) {
            return `${milliseconds} ms`;
        }
        const seconds = (milliseconds / 1000).toFixed(1);
        return `${seconds} s`;
    }
}
